import { Link } from 'react-router';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export function NotFoundPage() {
  useDocumentMeta({ title: '페이지를 찾을 수 없어요', noIndex: true });
  return (
    <div className="card flex flex-col items-center gap-4 p-8 text-center">
      <span className="text-5xl" aria-hidden="true">
        🍽️
      </span>
      <h1 className="text-xl font-bold">페이지를 찾을 수 없어요</h1>
      <p className="text-sm text-charcoal-500">주소를 다시 확인해주세요.</p>
      <Link to="/" className="btn-primary btn-md">
        홈으로
      </Link>
    </div>
  );
}
